<div class="footer">
  <section class="footer__content">
    <h3 class="header">Nice Links</h3>
    <ul class="links">
      <li class="link" *ngFor="let item of content">
        <a smNavigate="{{ item.link }}">{{ item.text }}</a>
      </li>
    </ul>
  </section>
  <section itemscope itemtype="https://schema.org/Organization" class="footer__contact">
    <h3 class="header">Contact</h3>
    <ul>
      <li itemprop="department" itemscope itemtype="https://schema.org/Organization" class="contact-branch" *ngFor="let contact of contacts">
        <h4 itemprop="name" class="sub-header">{{ contact.department }}</h4>
        <ul class="links">
          <li itemprop="address" *ngIf="contact.address" class="address link">{{ contact.address }}</li>
          <li *ngIf="contact.phone" class="link">
            Phone: <a href="tel: {{ contact.phone }}">{{ contact.phone }}</a>
            <meta itemprop="telephone" content="{{ contact.phone }}">
          </li>
          <li *ngIf="contact.email" class="link">
            Mail: <a href="mailto: {{ contact.email }}">{{ contact.email }}</a>
            <meta itemprop="email" content="{{ contact.email }}"/>
          </li>
        </ul>
      </li>
    </ul>
  </section>
  <section class="footer__details">
      <h3 *ngIf="formNotSubmitted$ | async" class="header">Let us call you</h3>
      <app-mailchimp-form [type]="type" (submitForm)="onSubmit()"></app-mailchimp-form>
  </section>
</div>
